import { Dispatch, GetState } from '../../types'
import { DateT } from '@mulesoft/anypoint-components/lib/DatePicker';
import { isUndefined } from 'util';
import * as selectors from './selectors'
import { fetchDetails } from '../ResourceSelector/actions';

/**
 *  Action Constants
 */
export const TimePickerChange = 'Monitoring/Dashboard/TimePickerChange';
export const TimePickerSet = 'Monitoring/Dashboard/TimePickerSet';
export const ApiStateChange = 'Monitoring/Dashboard/ApiStateChange';
export const RefreshChange = 'Monitoring/Dashboard/RefreshChange';

/**
 *  Action Type
 */
export type TimePickerChangeAction = {
  type: 'Monitoring/Dashboard/TimePickerChange'
  payload: {
    time: { from: string, to: string },
    refresh: string,
    initialDate: DateT
  }
}

export type TimePickerSetAction = {
  type: 'Monitoring/Dashboard/TimePickerSet'
  payload: {
    time: { from: string, to: string },
    refresh: string,
    initialDate: DateT
  }
}

export type ApiStateChangeAction = {
  type: 'Monitoring/Dashboard/ApiStateChange'
  payload: { isLoading: boolean }
}

export type RefreshAction = {
  type: 'Monitoring/Dashboard/RefreshChange'
  payload: { isRefreshing: boolean }
}

/**
 *  Action Creators
 */
export const timeSet = (time: { from: string, to: string },
                        autoRefresh: string,
                        initialDateD?: DateT) => (dispatch: Dispatch, getState: GetState) => {
  const initialDate = isUndefined(initialDateD) ? selectors.getInitialDate(getState()) : initialDateD;
  const lsAutoRefresh = window.localStorage.getItem('auto-refresh')
  const refresh = lsAutoRefresh ? lsAutoRefresh : autoRefresh

  dispatch({
    type: TimePickerSet,
    payload: {time, refresh, initialDate}
  })
};

export const timeChange = (time: { from: string, to: string },
                           refresh: string,
                           initialDateD?: DateT) => (dispatch: Dispatch, getState: GetState) => {
  const initialDate = isUndefined(initialDateD) ? selectors.getInitialDate(getState()) : initialDateD;
  window.localStorage.setItem('auto-refresh', refresh)

  dispatch({
    type: TimePickerChange,
    payload: {time, refresh, initialDate}
  })
};

export const apiState = (isLoading: boolean) => (dispatch: Dispatch) => {
  dispatch({
    type: ApiStateChange,
    payload: {isLoading}
  })
};

export const refreshing = (isRefreshing: boolean) => (dispatch: Dispatch, getState: GetState) => {
  if (isRefreshing !== selectors.isRefreshing(getState())) {
    dispatch({
      type: RefreshChange,
      payload: {isRefreshing}
    });
    if (isRefreshing) {
      dispatch(fetchDetails())
    }
  }
};

export type TimePickerActions =
  | TimePickerChangeAction
  | TimePickerSetAction
  | RefreshAction
  | ApiStateChangeAction
